/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Form_Default_NoteInputs */

const vi_carrier_form_default_note = /** @type {(inputs: Carrier_Form_Default_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chè Hảo Đạt`)
};

/**

* @param {Carrier_Form_Default_NoteInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_form_default_note = /** @type {((inputs?: Carrier_Form_Default_NoteInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Form_Default_NoteInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_form_default_note(inputs)
});